






























import Vue from "vue";
import { Rules } from "@ct/validations";
import FORGOT_PASSWORD from "@/graphql/ForgotPasswordMutation.gql";
import {
  ForgotPasswordMutation,
  ForgotPasswordMutationVariables
} from "@/graphql/generatedTypes/ForgotPasswordMutation";
import { AlertBar } from "@ct/alert";

export default Vue.extend({
  name: "ForgotPassword",
  metaInfo: {
    title: "Intro To IMS - Forgot Password",
    meta: [
      {
        property: "og:title",
        content: "Intro To IMS - Forgot Password"
      },
      {
        property: "og:image",
        content: "https://res.cloudinary.com/dm1xkelzx/image/upload/q_auto/v1686607172/IMS_Triangle_hcfwcc.png"
      }
    ]
  },
  components: { AlertBar },
  data() {
    return {
      email: "",
      rules: Rules
    };
  },
  methods: {
    async resetPassword() {
      if (!(this.$refs.form as HTMLFormElement).validate()) {
        return;
      }

      try {
        await this.$apollo.mutate<ForgotPasswordMutation, ForgotPasswordMutationVariables>({
          mutation: FORGOT_PASSWORD,
          variables: { input: { email: this.email } }
        });

        await this.$alertService.addAlert({
          message: "Password reset instructions have been sent to you",
          type: "info"
        });

        this.email = "";
        (this.$refs.form as HTMLFormElement).reset();
      } catch (e) {
        await this.$alertService.addAlert({
          message: "Request failed please try again",
          type: "error"
        });
      }
    }
  }
});
